export interface CompanyDropdownActionType {
  type: CompanyDropdown;
  payload?: any;
}

export enum CompanyDropdown {
  GET_COMPANY_DROPDOWN_LIST = "GET_COMPANY_DROPDOWN_LIST",
  SET_COMPANY_DROPDOWN_LIST = "SET_COMPANY_DROPDOWN_LIST",
  SET_COMPANY_DROPDOWN_LOADING = "SET_COMPANY_DROPDOWN_LOADING",
}
